import React from 'react'

const QuickFitDashboardTitle = ({ title }) => {
  return <>{title} </>
}

export default QuickFitDashboardTitle
